const checkboxes = document.querySelectorAll('.item-checkbox');
const frequantlyBuyATCBtn = document.getElementById('frequantly_buy_atc_btn');

function updateTotal() {
  let total = 0;
  let originalTotal = 0;

  checkboxes.forEach((checkbox) => {
    const container = checkbox.closest('.item-container');
    const item = container.querySelector('.item');
    const price = parseFloat(checkbox.dataset.price) || 0;
    const originalPrice = parseFloat(checkbox.dataset.originalPrice) || price;

    if (checkbox.checked) {
      total += price;
      originalTotal += originalPrice;
      item.classList.add('selected');
    } else {
      item.classList.remove('selected');
    }
  });
  const savings = originalTotal - total;
  document.getElementById('totalPrice').textContent = `${localizeCurrency(total)}`;
  document.getElementById('savings').textContent = savings > 0 ? `You save ${localizeCurrency(savings)}` : '';
}

function localizeCurrency(amount) {
  const locale = window.Shopify.locale;
  const country = window.Shopify.country;
  const currencyCode = window.Shopify.currency.active;

  return new Intl.NumberFormat(`${locale}-${country}`, {
    style: 'currency',
    currency: currencyCode,
  }).format(amount);
}

function toggleItem(container) {
  const checkbox = container.querySelector('.item-checkbox');
  const item = container.querySelector('.item');
  checkbox.checked = !checkbox.checked;
  if (checkbox.checked) {
    item.classList.add('selected');
  } else {
    item.classList.remove('selected');
  }
  updateTotal();
  updateFreqATCBtnState();
}

function updateFreqATCBtnState() {
  const container = document.querySelector('.section-content-wrapper');
  const anyChecked = [...container.querySelectorAll('.item-checkbox')].some((cb) => cb.checked);
  frequantlyBuyATCBtn.disabled = !anyChecked;
}

/******/ (() => {
/* eslint-disable */

class FrequentlyBuyForm extends HTMLElement {
  constructor() {
    super();
    this.cacheDOM();
    this.onSubmitBound = this.onSubmit.bind(this);
  }

  /* ===============================
     INIT
     =============================== */

  cacheDOM() {
    this.form = this.querySelector('form');
    this.sectionId = this.dataset.sectionId;
    this.cartType = document.getElementById('PageContainer')?.dataset.cartType;
    this.cartCountIndicator = document.querySelector('[data-cart-count-indicator]');
    this.errorWrapper = this.querySelector('.product-form__error-message-wrapper');
  }

  connectedCallback() {
    if (!this.form) return;
    this.form.addEventListener('submit', this.onSubmitBound);
  }

  disconnectedCallback() {
    this.form.removeEventListener('submit', this.onSubmitBound);
  }

  /* ===============================
     CHECKBOX SELECTION (OUTSIDE FORM)
     =============================== */

  getSelectedItems() {
    return [...document.querySelectorAll('.item-checkbox:checked')].map(cb => ({
      id: Number(cb.dataset.variantid),
      quantity: 1
    }));
  }

  /* ===============================
     SUBMIT
     =============================== */

  onSubmit(event) {
    event.preventDefault();
    this.clearError();
    this.setLoading(true);
    this.addItemsToCart();
  }

  /* ===============================
     ADD TO CART
     =============================== */

  async addItemsToCart() {
    try {
      const items = this.getSelectedItems();

      if (!items.length) {
        this.renderError('Please select at least one product.');
        this.setLoading(false);
        return;
      }

      const payload = { items };

      if (this.cartType === 'drawer') {
        payload.sections = 'cart-drawer';
      }

      const response = await fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Content-Type': 'application/json',
          Accept: 'application/javascript'
        },
        body: JSON.stringify(payload)
      });

      const responseText = await response.text();
      const result = responseText ? JSON.parse(responseText) : {};

      /* ===== Error handling (max qty / sold out etc.) ===== */
      if (!response.ok) {
        this.renderError(result.description || result.message);
        this.setLoading(false);
        return;
      }

      /* ===== Drawer update ===== */
      if (this.cartType === 'drawer' && result.sections) {
        this.renderCartDrawer(result.sections);
      } else {
        // Cart page behavior (same as ProductForm)
        window.location = window.routes.cart_url;
      }

      this.afterSuccess();

    } catch (error) {
      console.error(error);
      this.renderError('Unable to add items to cart.');
      this.setLoading(false);
    }
  }

  /* ===============================
     DRAWER RENDER (CRITICAL FIX)
     =============================== */

  renderCartDrawer(sections) {
    Object.entries(sections).forEach(([id, html]) => {
      const container = document.getElementById(id);
      if (container) {
        container.innerHTML = html;
      }
    });

    window.eventBus.emit('render:cart:drawer');
    window.eventBus.emit('open:cart:drawer', { scrollToTop: true });
  }

  /* ===============================
     AFTER SUCCESS
     =============================== */

  async afterSuccess() {
    this.setLoading(false);
    window.eventBus.emit('cart:added', { sectionId: this.sectionId });
    await this.updateCartCount();
  }

  /* ===============================
     CART COUNT
     =============================== */

  async updateCartCount() {
    if (!this.cartCountIndicator) return;

    const cart = await fetch(`${window.routes.cart_url}?view=compare`)
      .then(res => res.json());

    window.wetheme?.updateCartCount(cart);
  }

  /* ===============================
     UI HELPERS
     =============================== */
  setLoading(state) {
    const button = this.querySelector('[type="submit"]');
    if (button) button.disabled = state;
    this.classList.toggle('is-loading', state);
  }

  renderError(message) {
    if (!this.errorWrapper) return;
    this.errorWrapper.textContent = message;
    this.errorWrapper.classList.remove('hidden');
  }

  clearError() {
    if (!this.errorWrapper) return;
    this.errorWrapper.textContent = '';
    this.errorWrapper.classList.add('hidden');
  }
}

if (!customElements.get('frequently-buy-form')) {
  customElements.define('frequently-buy-form', FrequentlyBuyForm);
}

})();
